var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageHeader',{attrs:{"add":{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'manage-setting-utility-add'},"title":_vm.$t('manage.utility.text')}}),_c('List',{attrs:{"dataList":_vm.data,"updating":_vm.fetchingStats,"navigate":_vm.pageNavigate,"formats":[{name: 'price', type: 'currency'}],"fields":[ 
          ("project_name: " + (_vm.$t('project.text'))),
          ("name: " + (_vm.$t('manage.service.name'))),
          ("name_en: " + (_vm.$t('manage.name_en'))),
          ("price: " + (_vm.$t('manage.utility.price'))) ],"edit":{link: 'manage-setting-utility-edit'},"filter":{
          search: ['mg_utilities.name','mg_utilities.name_en']
        }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }